import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import Common from './Common';
import Auth from './Auth';
import Users from './Users';
import Rfm from './Rfm';


export default history =>
  combineReducers({
    router: connectRouter(history),
    common: Common,
    auth: Auth,
    Users: Users,
    Rfm: Rfm,

  });
